import template from '../../../../../../Template/config/components/scorecard/ScorecardView/ScorecardStatTesting';
export default {
  ...template,
  legendDetails: ["Negative sentiments shaded in reverse."]
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTech/config/components/scorecard/ScorecardView/ScorecardStatTesting/index.js